import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, post } from '../http';
import { activeSnack } from './common';

// import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const getAllAdvertisingAccounts = createAsyncThunk(
  'advertiser/list',
  async ({ page, search, dispatch, limit, sort, date }) => {
    try {
      const response = await post(
        `/advertiser-account/admin/all?page=${page && page}&search=${search && search}&limit=${
          limit || 5
        }&sort=${sort || ''}&from=${date?.from || ''}&to=${date?.to || ''}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const initiateAdvertiserData = createAsyncThunk(
  'advertiser/initiate',
  async ({ enqueueSnackbar }) => {
    try {
      const response = await get('/advertiser-account/advertiser/intitiate');
      if (response) {
        enqueueSnackbar(response.message, { variant: 'success' });
        return response;
      }
      return enqueueSnackbar('Something went wrong while fetching data', { variant: 'error' });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message || 'Failed to fetch data', { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

// --- REDUX SLICE START ---
export const AdvertisingAccountSlice = createSlice({
  name: 'advertising-accounts',
  initialState: {
    loading: false,
    error: {},
    // staff
    advertiserAccounts: {},
    referralMembers: {},
    clubIncomeTransactions: {},
    memberDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllAdvertisingAccounts.pending]: (state) => {
      state.loading = true;
    },
    [getAllAdvertisingAccounts.fulfilled]: (state, action) => {
      state.loading = false;
      state.advertiserAccounts = action.payload;
      state.error = {};
    },
    [getAllAdvertisingAccounts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [initiateAdvertiserData.pending]: (state) => {
      state.loading = true;
    },
    [initiateAdvertiserData.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = {};
    },
    [initiateAdvertiserData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = AdvertisingAccountSlice.actions;

export default AdvertisingAccountSlice.reducer;
